import { render, staticRenderFns } from "./NsProductVariantSelector.vue?vue&type=template&id=0cf3388a&scoped=true&"
import script from "./NsProductVariantSelector.vue?vue&type=script&lang=js&"
export * from "./NsProductVariantSelector.vue?vue&type=script&lang=js&"
import style0 from "./NsProductVariantSelector.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./NsProductVariantSelector.vue?vue&type=style&index=1&id=0cf3388a&lang=scss&scoped=true&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./NsProductVariantSelector.vue?vue&type=style&index=0&lang=scss&module=true&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./NsProductVariantSelector.vue?vue&type=style&index=0&lang=scss&module=true&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js").rerender("0cf3388a")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0cf3388a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cf3388a')) {
      api.createRecord('0cf3388a', component.options)
    } else {
      api.reload('0cf3388a', component.options)
    }
    module.hot.accept("./NsProductVariantSelector.vue?vue&type=template&id=0cf3388a&scoped=true&", function () {
      api.rerender('0cf3388a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/product-components/components/NsProductVariantSelector.vue"
export default component.exports